var _a, _b;
import createTheme from '@material-ui/core/styles/createTheme';
var root = document.querySelector(':root');
var rootStyles = root ? getComputedStyle(root) : null;
export default createTheme({
    typography: {
        fontFamily: [
            'OpenSans',
            'Roboto',
            '"Helvetica Neue"',
            'Arial',
            'sans-serif'
        ].join(','),
        h6: { fontWeight: 600 },
        overline: { lineHeight: 1.175 },
        subtitle1: { lineHeight: 1.5 }
    },
    palette: {
        primary: { main: ((_a = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-primary')) === null || _a === void 0 ? void 0 : _a.trim()) || '#f15623' },
        secondary: { main: ((_b = rootStyles === null || rootStyles === void 0 ? void 0 : rootStyles.getPropertyValue('--color-secondary')) === null || _b === void 0 ? void 0 : _b.trim()) || '#375b7d' },
        //primary: { main: '#f15623' },
        //secondary: { main: '#375b7d' },
    }
});
